// assets/js/components/revenue-calculator/steps/step-entry.js
var ui = require("../ui");

function render() {
    return ui.card(
        '<p class="p p--bold rc-calc__eyebrow">' + _t("Revenue Calculator") + "</p>" +
        '<h3 class="title title--h3 rc-calc__title">' + _t("How much revenue is your business leaving on the table each month?") + "</h3>" +
        '<p class="p rc-calc__intro">' + _t("Get a quick estimate or continue for a more detailed analysis of your revenue opportunities.") + "</p>" +
        ui.primaryButton({ id: "rc-start-btn", label: _t("Start your revenue check") }) +
        '<p class="p rc-calc__microcopy cursive">' + _t("Takes about 2 minutes. No signup needed to begin") + "</p>",
        "rc-calc__card--entry"
    );
}

function bind(container, state, actions) {
    container.querySelector("#rc-start-btn").addEventListener("click", function () {
        state.step = 1;
        actions.rerender();
    });
}

module.exports = { render: render, bind: bind };
